
const AppConfig = {
  clientApiURL: "http://127.0.0.1:8000/",
  // clientApiURL: "http://13.233.204.19:8000/",
};

export {
  AppConfig
};
